import { render, staticRenderFns } from "./grouping-package.vue?vue&type=template&id=fc670568&"
import script from "./grouping-package.vue?vue&type=script&lang=ts&"
export * from "./grouping-package.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports